import React from 'react';
import styles from './Pager.module.scss';

interface PagerProps {
  /** Current page (0-based). */
  page: number;
  pageCount: number;
  /** 1-based index of the first item shown. */
  from: number;
  /** 1-based index of the last item shown. */
  to: number;
  total: number;
  onChange: (page: number) => void;
}

/** Prev/Next pager matching the reference design's `.pager`; its props line up with what `usePagination` returns. */
export const Pager: React.FC<PagerProps> = ({ page, pageCount, from, to, total, onChange }) => (
  <div className={styles.pager}>
    <div className={styles.pagerControls}>
      <button
        type="button"
        className={styles.pagerBtn}
        disabled={page === 0}
        onClick={() => onChange(page - 1)}
      >
        Prev
      </button>
      <span className={styles.pagerPage}>
        Page {page + 1} of {pageCount}
      </span>
      <button
        type="button"
        className={styles.pagerBtn}
        disabled={page >= pageCount - 1}
        onClick={() => onChange(page + 1)}
      >
        Next
      </button>
    </div>
    <span className={styles.pagerInfo}>
      {from}–{to} of {total}
    </span>
  </div>
);

export default Pager;
